import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const cashRegisterSave: TypedDocumentNode<
    Pick<GQL.IMutation, "cashRegisterSave">,
    GQL.IMutationCashRegisterSaveArgs
> = gql`
    mutation cashRegisterSave($input: CashRegisterSaveInput!) {
        cashRegisterSave(input: $input) {
            id
            companyId
            name
            color
            isFavorite
            accountingCashRegisterId
            createdAt
            updatedAt
        }
    }
`;

export const cashRegisterDelete: TypedDocumentNode<
    Pick<GQL.IMutation, "cashRegisterDelete">,
    GQL.IMutationCashRegisterDeleteArgs
> = gql`
    mutation cashRegisterDelete($input: IDCompanyIDInput!) {
        cashRegisterDelete(input: $input)
    }
`;

export const cashRegisterMarkFavorite: TypedDocumentNode<
    Pick<GQL.IMutation, "cashRegisterMarkFavorite">,
    GQL.IMutationCashRegisterMarkFavoriteArgs
> = gql`
    mutation cashRegisterMarkFavorite($input: IDCompanyIDInput!) {
        cashRegisterMarkFavorite(input: $input)
    }
`;

export const cashRegisterAccountingBind: TypedDocumentNode<
    Pick<GQL.IMutation, "cashRegisterAccountingBind">,
    GQL.IMutationCashRegisterAccountingBindArgs
> = gql`
    mutation cashRegisterAccountingBind($input: AccountingBindInput!) {
        cashRegisterAccountingBind(input: $input) {
            id
        }
    }
`;

export const cashRegisterTransactionSave: TypedDocumentNode<
    Pick<GQL.IMutation, "cashRegisterTransactionSave">,
    GQL.IMutationCashRegisterTransactionSaveArgs
> = gql`
    mutation cashRegisterTransactionSave(
        $companyId: ID!
        $cashRegisterId: ID!
        $input: CashRegisterTransactionSaveInput!
    ) {
        cashRegisterTransactionSave(companyId: $companyId, cashRegisterId: $cashRegisterId, input: $input)
    }
`;

export const cashRegisterTransactionsDelete: TypedDocumentNode<
    Pick<GQL.IMutation, "cashRegisterTransactionsDelete">,
    GQL.IMutationCashRegisterTransactionsDeleteArgs
> = gql`
    mutation cashRegisterTransactionsDelete($ids: IDsCompanyIDInput!, $cashRegisterId: ID!) {
        cashRegisterTransactionsDelete(ids: $ids, cashRegisterId: $cashRegisterId)
    }
`;

export const cashRegisterTransactionSetDmsDocumentIds: TypedDocumentNode<
    Pick<GQL.IMutation, "cashRegisterTransactionSetDmsDocumentIds">,
    GQL.IMutationCashRegisterTransactionSetDmsDocumentIdsArgs
> = gql`
    mutation cashRegisterTransactionSetDmsDocumentIds(
        $id: IDCompanyIDInput!
        $cashRegisterId: ID!
        $documents: [EntityDocumentIdInput!]!
    ) {
        cashRegisterTransactionSetDmsDocumentIds(id: $id, cashRegisterId: $cashRegisterId, documents: $documents)
    }
`;

export const cashRegisterTransactionsColor: TypedDocumentNode<
    Pick<GQL.IMutation, "cashRegisterTransactionsColor">,
    GQL.IMutationCashRegisterTransactionsColorArgs
> = gql`
    mutation cashRegisterTransactionsColor($ids: IDsCompanyIDInput!, $cashRegisterId: ID!, $color: DocumentColors) {
        cashRegisterTransactionsColor(ids: $ids, cashRegisterId: $cashRegisterId, color: $color)
    }
`;

export const cashRegisterTransactionsCreateFromDocuments: TypedDocumentNode<
    Pick<GQL.IMutation, "cashRegisterTransactionsCreateFromDocuments">,
    GQL.IMutationCashRegisterTransactionsCreateFromDocumentsArgs
> = gql`
    mutation cashRegisterTransactionsCreateFromDocuments($companyId: ID!, $cashRegisterId: ID!, $documentIds: [ID!]!) {
        cashRegisterTransactionsCreateFromDocuments(
            companyId: $companyId
            cashRegisterId: $cashRegisterId
            documentIds: $documentIds
        ) {
            documentId
            outcome
            transactionId
            reason
        }
    }
`;
